// Generated by purs version 0.15.15
import * as Control_Alt from "../Control.Alt/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Category from "../Control.Category/index.js";
import * as Control_Monad_Except_Trans from "../Control.Monad.Except.Trans/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Identity from "../Data.Identity/index.js";
import * as Data_List_Types from "../Data.List.Types/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Symbol from "../Data.Symbol/index.js";
import * as Foreign from "../Foreign/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Type_Proxy from "../Type.Proxy/index.js";
var map = /* #__PURE__ */ Data_Functor.map(/* #__PURE__ */ Control_Monad_Except_Trans.functorExceptT(Data_Identity.functorIdentity));
var alt = /* #__PURE__ */ Control_Alt.alt(/* #__PURE__ */ Control_Monad_Except_Trans.altExceptT(Data_List_Types.semigroupNonEmptyList)(Data_Identity.monadIdentity));
var bindExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.bindExceptT(Data_Identity.monadIdentity);
var bind = /* #__PURE__ */ Control_Bind.bind(bindExceptT);
var readString = /* #__PURE__ */ Foreign.readString(Data_Identity.monadIdentity);
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit)(bindExceptT);
var applicativeExceptT = /* #__PURE__ */ Control_Monad_Except_Trans.applicativeExceptT(Data_Identity.monadIdentity);
var unless = /* #__PURE__ */ Control_Applicative.unless(applicativeExceptT);
var fail = /* #__PURE__ */ Foreign.fail(Data_Identity.monadIdentity);
var show = /* #__PURE__ */ Data_Show.show(Data_Show.showString);
var pure = /* #__PURE__ */ Control_Applicative.pure(applicativeExceptT);
var encodeEnum = function (dict) {
    return dict.encodeEnum;
};
var genericEncodeEnum = function (dictGeneric) {
    var from = Data_Generic_Rep.from(dictGeneric);
    return function (dictGenericEncodeEnum) {
        var encodeEnum1 = encodeEnum(dictGenericEncodeEnum);
        return function (opts) {
            var $64 = encodeEnum1(opts);
            return function ($65) {
                return $64(from($65));
            };
        };
    };
};
var sumGenericEncodeEnum = function (dictGenericEncodeEnum) {
    var encodeEnum1 = encodeEnum(dictGenericEncodeEnum);
    return function (dictGenericEncodeEnum1) {
        var encodeEnum2 = encodeEnum(dictGenericEncodeEnum1);
        return {
            encodeEnum: function (v) {
                return function (v1) {
                    if (v1 instanceof Data_Generic_Rep.Inl) {
                        return encodeEnum1(v)(v1.value0);
                    };
                    if (v1 instanceof Data_Generic_Rep.Inr) {
                        return encodeEnum2(v)(v1.value0);
                    };
                    throw new Error("Failed pattern match at Foreign.Generic.EnumEncoding (line 93, column 1 - line 97, column 46): " + [ v.constructor.name, v1.constructor.name ]);
                };
            }
        };
    };
};
var defaultGenericEnumOptions = {
    constructorTagTransform: /* #__PURE__ */ Control_Category.identity(Control_Category.categoryFn)
};
var decodeEnum = function (dict) {
    return dict.decodeEnum;
};
var genericDecodeEnum = function (dictGeneric) {
    var to = Data_Generic_Rep.to(dictGeneric);
    return function (dictGenericDecodeEnum) {
        var decodeEnum1 = decodeEnum(dictGenericDecodeEnum);
        return function (opts) {
            var $66 = map(to);
            var $67 = decodeEnum1(opts);
            return function ($68) {
                return $66($67($68));
            };
        };
    };
};
var sumGenericDecodeEnum = function (dictGenericDecodeEnum) {
    var decodeEnum1 = decodeEnum(dictGenericDecodeEnum);
    return function (dictGenericDecodeEnum1) {
        var decodeEnum2 = decodeEnum(dictGenericDecodeEnum1);
        return {
            decodeEnum: function (opts) {
                return function (f) {
                    return alt(map(Data_Generic_Rep.Inl.create)(decodeEnum1(opts)(f)))(map(Data_Generic_Rep.Inr.create)(decodeEnum2(opts)(f)));
                };
            }
        };
    };
};
var ctorProductGenericEncodeEnum = function () {
    return {
        encodeEnum: function (v) {
            return function (v1) {
                return Partial_Unsafe.unsafeCrashWith("unreachable encodeEnum was reached.");
            };
        }
    };
};
var ctorProductGenericDecodeEnum = function () {
    return {
        decodeEnum: function (v) {
            return function (v1) {
                return Partial_Unsafe.unsafeCrashWith("unreachable decodeEnum was reached.");
            };
        }
    };
};
var ctorNoArgsGenericEncodeEnum = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    return {
        encodeEnum: function (v) {
            return function (v1) {
                var ctorName = v.constructorTagTransform(reflectSymbol(Type_Proxy["Proxy"].value));
                return Foreign.unsafeToForeign(ctorName);
            };
        }
    };
};
var ctorNoArgsGenericDecodeEnum = function (dictIsSymbol) {
    var reflectSymbol = Data_Symbol.reflectSymbol(dictIsSymbol);
    return {
        decodeEnum: function (v) {
            return function (f) {
                var ctorName = v.constructorTagTransform(reflectSymbol(Type_Proxy["Proxy"].value));
                return bind(readString(f))(function (tag) {
                    return discard(unless(tag === ctorName)(fail(new Foreign.ForeignError("Expected " + (show(ctorName) + (" tag for unary constructor literal " + ctorName))))))(function () {
                        return pure(Data_Generic_Rep.NoArguments.value);
                    });
                });
            };
        }
    };
};
var ctorArgumentGenericEncodeEnum = function () {
    return {
        encodeEnum: function (v) {
            return function (v1) {
                return Partial_Unsafe.unsafeCrashWith("unreachable encodeEnum was reached.");
            };
        }
    };
};
var ctorArgumentGenericDecodeEnum = function () {
    return {
        decodeEnum: function (v) {
            return function (v1) {
                return Partial_Unsafe.unsafeCrashWith("unreachable decodeEnum was reached.");
            };
        }
    };
};
export {
    decodeEnum,
    encodeEnum,
    defaultGenericEnumOptions,
    genericDecodeEnum,
    genericEncodeEnum,
    sumGenericDecodeEnum,
    ctorNoArgsGenericDecodeEnum,
    ctorArgumentGenericDecodeEnum,
    ctorProductGenericDecodeEnum,
    sumGenericEncodeEnum,
    ctorNoArgsGenericEncodeEnum,
    ctorArgumentGenericEncodeEnum,
    ctorProductGenericEncodeEnum
};
